"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the last value in an array. Returns `undefined` if the array is empty.
 */
function last(array) {
    return array[array.length - 1];
}
exports.default = last;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGFzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9sYXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7O0dBRUc7QUFDSCxTQUF3QixJQUFJLENBQUksS0FBVTtJQUN4QyxPQUFPLEtBQUssQ0FBQyxLQUFLLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQyxDQUFDO0FBQ2pDLENBQUM7QUFGRCx1QkFFQyJ9